import React, { useLayoutEffect, useContext } from "react";
import ApiDeviceType from "../../../app/api/admin/device-type/ApiDeviceType";
import Page from "../../modules/page";
import { ContextPage } from "../../modules/page/pageContext";
import { ContextContent } from "../../modules/content/contentContext";
import List from "../../modules/list";
import ListHeaderItem from "../../modules/list/__header-item";
import ListBodyItem from "../../modules/list/__body-item";
import ButtonLinkShow from "../../components/button-link/__show";
import ButtonLinkAdd from "../../components/button-link/__add";

// Список типов устройств (сервер сортирует по name; фильтров/сортировки query нет).
export default function DeviceTypesIndex({ ...other }) {
    return <Page {...other}>
        <DeviceTypesIndexContent/>
    </Page>;
}

function DeviceTypesIndexContent() {
    const contextContent = useContext(ContextContent);
    const contextPage = useContext(ContextPage);

    useLayoutEffect(() => {
        contextContent.setTitle('Типы устройств');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const header = [
        <ListHeaderItem key="id" name="id" isSort={false}>ID</ListHeaderItem>,
        <ListHeaderItem key="name" name="name" isSort={false}>Название</ListHeaderItem>,
        <ListHeaderItem key="resources" name="resources" isSort={false}>Ресурсы</ListHeaderItem>,
        <ListHeaderItem key="screen" name="screen" isSort={false}>Экран</ListHeaderItem>,
        <ListHeaderItem key="is_active" name="is_active" isSort={false}>Активен</ListHeaderItem>,
        <ListHeaderItem key="create" name="create" isSort={false}>
            {contextContent.checkPermission('create')
                ? <ButtonLinkAdd className="button-link_white" title="Добавить" href={contextPage.routes.create.url()}/> : null}
        </ListHeaderItem>,
    ];

    const renderRow = (row) => [
        <ListBodyItem key="id">{row.id}</ListBodyItem>,
        <ListBodyItem key="name">{row.name}</ListBodyItem>,
        <ListBodyItem key="resources">
            {row.cpu_cores ?? '—'} ядер / {row.ram_mb ?? '—'} МБ / {row.disk_mb ?? '—'} МБ
        </ListBodyItem>,
        <ListBodyItem key="screen">{row.screen_w}×{row.screen_h}</ListBodyItem>,
        <ListBodyItem key="is_active">
            <span className={`badge ${row.is_active ? 'badge_online' : ''}`}>{row.is_active ? 'да' : 'нет'}</span>
        </ListBodyItem>,
        <ListBodyItem key="show">
            {contextContent.checkPermission('show')
                ? <ButtonLinkShow className="button-link_blue" title="Просмотр" href={contextPage.routes.show.url({ id: row.id })}/> : null}
        </ListBodyItem>,
    ];

    return <List
        header={header}
        ApiModel={ApiDeviceType}
        renderRow={renderRow}
        defaultSortKey="name"
        defaultSortIsAsc={true}
    />;
}
